(function() {
  var names = [
    "Andrei Moza", "Maria Ionescu", "Ștefan Popescu", "Ioana Rusu", "Cristian Dumitru",
    "Alexandra Stan", "Mihai Constantin", "Elena Marin", "Bogdan Neagu", "Diana Toma",
    "Radu Petrescu", "Georgiana Iliescu", "Vlad Ciobanu", "Andreea Preda", "Marius Barbu",
    "Cristina Lungu", "Florin Matei", "Roxana Enache", "Adrian Voicu", "Simona Dinu",
    "Gabriel Nistor", "Daniela Cojocaru", "Sorin Anghel", "Raluca Pavel", "Cătălin Șerban",
    "Nicoleta Grigore", "Dan Vasilescu", "Laura Bălan", "Eugen Munteanu", "Iulia Tudor"
  ];
  var cities = [
    "Iași", "Cluj-Napoca", "Timișoara", "București", "Constanța", "Craiova", "Brașov",
    "Oradea", "Galați", "Ploiești", "Sibiu", "Bacău", "Arad", "Târgu Mureș", "Baia Mare"
  ];

  function randomBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function updateViewers() {
    document.querySelectorAll('.viewers-count').forEach(function(el) {
      el.textContent = randomBetween(14, 56);
    });
  }

  function showOrderNotice() {
    document.querySelectorAll('.order-notice').forEach(function(el) {
      var name = names[Math.floor(Math.random() * names.length)];
      var city = cities[Math.floor(Math.random() * cities.length)];
      var qty = randomBetween(1, 3);
      el.innerHTML = '<strong>' + name + '</strong> din ' + city + ' a comandat chiar acum ' + qty + ' ' + (qty === 1 ? 'bucată' : 'bucăți');
      el.classList.remove('order-notice--visible');
      void el.offsetWidth;
      el.classList.add('order-notice--visible');
    });
  }

  updateViewers();
  setInterval(updateViewers, 8000);

  showOrderNotice();
  setInterval(showOrderNotice, 6000);
})();